var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Curva de capital")]),_c('div',{staticClass:"simulador-highchart"},[_c('div',{attrs:{"id":"highchart-content-curve"}})])])}]

export { render, staticRenderFns }